import React from 'react';
import { Helmet } from 'react-helmet-async';

/* This is a licensing requirement to use the Helvetica Neue font provided by the component library */
const FontTracking: React.FC = () => (
  <Helmet>
    <style type="text/css">
      @import
      url("https://fast.fonts.net/lt/1.css?apiType=css&c=6ecd3b2f-0b43-4802-a09d-52786c84ee6c&fontids=1289720,1289726,1289729,1289734,1289737,1289744,1289751,1289756,1488864,1488870,1488876,1488882,1488888,1488906,1488918,1488924,1488930,1488936,1488942,1488960,1488966,1488972,1488984,1488996,1489002,1489008,1489014,1489020,1489026,1489032,1489038,1489044,1489050,1489056,1489062,1489068,1489074,1489080,1489086,1489092,1489098,1489104,1489110,1489116,1489122,1489128,1489134,1489140,5541257,5541275,5658420,5663715,5663726,5663775,5664069,5664092,5664096,5664105,5664126");
    </style>
  </Helmet>
);

export default FontTracking;
